/**
 * Remove sensitive info from url
 */
var replaceSensitive = function replaceSensitive(url) {
  return url.replace(/(email|token|auth)=[^&]*/g, "$1=REDACTED");
};
export default {
  replaceSensitive: replaceSensitive
};